import React from 'react'

import { Space, TextBody, TextHeading } from '@ally/metronome-ui'
import { CallUsBlock } from '@ally/ally-login'

import { useHostServices } from '../../HostServices'

export const NoMfaOptionError: React.FC = () => {
  const { analytics, featureFlags } = useHostServices()

  React.useEffect(() => {
    analytics.trackPageView({
      eventType: 'pageview',
      pageName: 'AOS:Mortgage:No Phone on File:Call Us',
    })
  }, [])

  return (
    <>
      <Space mb="md">
        <TextHeading tag="h1" size="lg" focusOnMount>
          Give us a call
        </TextHeading>
      </Space>
      <Space mb="md">
        <TextBody tag="p" size="sm">
          Looks like we don&apos;t have a phone number on file for your account.
          Give us a call so we can add one.
        </TextBody>
      </Space>
      <CallUsBlock variation={featureFlags.variation} />
    </>
  )
}
